import {wrap} from '../../shared/loading-overlay'
const actionTypes = [
  {
    typeId: 'APPLICATION_CREATE',
    name: 'Application created',
    category: 'application',
  },
  {
    typeId: 'APPLICATION_DELETE',
    name: 'Application deleted',
    category: 'application',
  },
  {
    typeId: 'APPLICATION_FOLLOW_CREATE',
    name: 'Application Follower created',
    category: 'application',
  },
  {
    typeId: 'APPLICATION_FOLLOW_DELETE',
    name: 'Application Follower deleted',
    category: 'application',
  },
  {
    typeId: 'APPLICATION_FOLLOW_UPDATE',
    name: 'Application Follower updated',
    category: 'application',
  },
  {
    typeId: 'APPLICATION_STAGE_CREATE',
    name: 'Application stage created',
    category: 'application_stage',
  },
  {
    typeId: 'APPLICATION_STAGE_UPDATE',
    name: 'Application stage updated',
    category: 'application_stage',
  },
  {
    typeId: 'APPLICATION_UPDATE',
    name: 'Application updated',
    category: 'application',
  },
  {
    typeId: 'APPROVAL_ACCEPT',
    name: 'Candidate approval accepted',
    category: 'user',
  },
  {
    typeId: 'APPROVAL_REJECT',
    name: 'Candidate approval rejected',
    category: 'user',
  },
  {
    typeId: 'APPROVAL_REQUEST',
    name: 'Candidate requests approval',
    category: 'user',
  },
  {
    typeId: 'APPROVAL_STATUS_UPDATE',
    name: 'Candidate approval status updated',
    category: 'user',
  },
  {
    typeId: 'BULK_CANDIDATE_ASSIGNED_AGENT_UPDATE',
    name: 'Bulk candidates assigned agent updated',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_ARCHIVE',
    name: 'Candidate archived',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_ASSIGNED_AGENT_UPDATE',
    name: 'Candidate assigned agent updated',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_EMPLOYER_BLOCK',
    name: 'Candidate blocks an employer',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_EMPLOYER_FOLLOW',
    name: 'Candidate follows an employer',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_EMPLOYER_HIDE',
    name: 'Candidate hides an employer',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_EMPLOYER_SHOW',
    name: 'Candidate follows an employer',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_LOCK',
    name: "candidate approval status is updated to 'Locked'",
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_POSITION_HIDE',
    name: 'Candidate hides a position',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_POSITION_SHOW',
    name: 'Candidate shows a position',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_PROFILE_CREATE',
    name: 'Candidate profile created',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_PROFILE_DELETE',
    name: 'Candidate profile created',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_PROFILE_UPDATE',
    name: 'Candidate updates their profile',
    category: 'user',
  },
  {
    typeId: 'CANDIDATE_UNLOCK',
    name: "candidate approval status is updated to 'Approved'",
    category: 'user',
  },
  {
    typeId: 'EMAIL_PAUSE',
    name: 'User have paused the Email',
    category: 'email',
  },
  {
    typeId: 'EMAIL_SCHEDULED',
    name: 'User email is scheduled',
    category: 'email',
  },
  {
    typeId: 'EMAIL_SENT',
    name: 'Email sent',
    category: 'email',
  },
  {
    typeId: 'EMAIL_SUBSCRIBE',
    name: 'User subscribed to Email',
    category: 'email',
  },
  {
    typeId: 'EMAIL_UNPAUSE',
    name: 'User have paused the Email',
    category: 'email',
  },
  {
    typeId: 'EMAIL_UNSUBSCRIBE',
    name: 'User unsubscribed to Email',
    category: 'email',
  },
  {
    typeId: 'EMAIL_UPDATE',
    name: 'Email CC or BCC updated',
    category: 'email',
  },
  {
    typeId: 'EMPLOYER_ASSIGNED_AGENT_UPDATE',
    name: 'Employer assigned agent updated',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_BLOCK',
    name: 'Employer blocked',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_CREATE',
    name: 'Employer created',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_DELETE',
    name: 'Employer deleted',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_ENQUIRY',
    name: 'Employer enquiry',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_FOLLOWED',
    name: 'Employer followed',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_HIDE',
    name: 'Employer hidden',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_SHOW',
    name: 'Employer shown',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_UNBLOCK',
    name: 'Employer unblocked',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_UN_FOLLOWED',
    name: 'Employer un followed',
    category: 'employer',
  },
  {
    typeId: 'EMPLOYER_UPDATE',
    name: 'Employer updated',
    category: 'employer',
  },
  {
    typeId: 'EXPERIENCE_CREATE',
    name: 'Candidate created new experience',
    category: 'user',
  },
  {
    typeId: 'EXPERIENCE_DELETE',
    name: 'Candidate deleted experience',
    category: 'user',
  },
  {
    typeId: 'EXPERIENCE_UPDATE',
    name: 'Candidate updated experience',
    category: 'user',
  },
  {
    typeId: 'EXTERNAL_USER_CREATE',
    name: 'External User Created',
    category: 'external_user',
  },
  {
    typeId: 'LOGIN',
    name: 'User logs in',
    category: 'user',
  },
  {
    typeId: 'LOGOUT',
    name: 'User logs out',
    category: 'user',
  },
  {
    typeId: 'NOTE_CREATE',
    name: 'Note created',
    category: 'note',
  },
  {
    typeId: 'NOTE_DELETE',
    name: 'Note deleted',
    category: 'note',
  },
  {
    typeId: 'NOTE_UPDATE',
    name: 'Note updated',
    category: 'note',
  },
  {
    typeId: 'PASSWORD_RESET',
    name: 'Password reset',
    category: 'user',
  },
  {
    typeId: 'POSITION_CREATE',
    name: 'Position created',
    category: 'position',
  },
  {
    typeId: 'POSITION_DELETE',
    name: 'Position deleted',
    category: 'position',
  },
  {
    typeId: 'POSITION_HIDE',
    name: 'Position hidden',
    category: 'position',
  },
  {
    typeId: 'POSITION_QUESTION',
    name: 'Asked a question',
    category: 'user',
  },
  {
    typeId: 'POSITION_QUESTION_SENT',
    name: 'Question sent via email',
    category: 'position',
  },
  {
    typeId: 'POSITION_SHOW',
    name: 'Position shown',
    category: 'position',
  },
  {
    typeId: 'POSITION_UPDATE',
    name: 'Position updated',
    category: 'position',
  },
  {
    typeId: 'POSITION_VIEW',
    name: 'Candidate views a position',
    category: 'user',
  },
  {
    typeId: 'PROFESSION_PROFILE_UPDATE',
    name: 'user profession profile updated',
    category: 'user',
  },
  {
    typeId: 'PROFILE_PHOTO_DELETE',
    name: 'user profile photo deleted',
    category: 'user',
  },
  {
    typeId: 'PROFILE_PHOTO_UPLOAD',
    name: 'user profile photo uploaded',
    category: 'user',
  },
  {
    typeId: 'REFERRAL_CREATE',
    name: 'Referral Created',
    category: 'referral',
  },
  {
    typeId: 'RESUME_CREATE',
    name: 'Candidate resume created',
    category: 'user',
  },
  {
    typeId: 'RESUME_DELETE',
    name: 'Candidate resume deleted',
    category: 'user',
  },
  {
    typeId: 'RESUME_UPDATE',
    name: 'Candidate resume updated',
    category: 'user',
  },
  {
    typeId: 'SALARY_CREATE',
    name: 'Candidate Salary Created',
    category: 'user',
  },
  {
    typeId: 'SALARY_DELETE',
    name: 'Candidate Salary deleted',
    category: 'user',
  },
  {
    typeId: 'SALARY_UPDATE',
    name: 'Candidate Salary Updated',
    category: 'user',
  },
  {
    typeId: 'TASK_FAIL',
    name: 'Scheduled task failed',
    category: 'scheduled_task',
  },
  {
    typeId: 'TASK_SUCCESS',
    name: 'Scheduled task ran successfully',
    category: 'scheduled_task',
  },
  {
    typeId: 'USER_ACTIVE',
    name: 'User is Active',
    category: 'user',
  },
  {
    typeId: 'USER_CORPORATE',
    name: 'Corporate Role added to User ',
    category: 'user',
  },
  {
    typeId: 'USER_CREATE',
    name: 'User Created',
    category: 'user',
  },
  {
    typeId: 'USER_DELETE',
    name: 'User is archived in database',
    category: 'user',
  },
  {
    typeId: 'USER_LOGIN',
    name: 'User logged in',
    category: 'user',
  },
  {
    typeId: 'USER_LOGOUT',
    name: 'User logged in',
    category: 'user',
  },
  {
    typeId: 'USER_SETTING_CREATE',
    name: 'user created specific setting',
    category: 'user',
  },
  {
    typeId: 'USER_SETTING_DELETE',
    name: 'user deleted specific setting',
    category: 'user',
  },
  {
    typeId: 'USER_SETTING_UPDATE',
    name: 'user updated specific setting',
    category: 'user',
  },
  {
    typeId: 'USER_SIGNUP',
    name: 'User signed up',
    category: 'user',
  },
  {
    typeId: 'USER_UPDATE',
    name: 'User Updated',
    category: 'user',
  },
]
function formatType(typeId) {
  const match = actionTypes.find(actionType => actionType.typeId === typeId)
  // eslint-disable-next-line no-negated-condition,no-extra-boolean-cast
  return match ? match.name : typeId
}

const getInformationFromPositionHideAction = action => {
  const hasPayload = action && action.payload && action.payload[0]
  const information = hasPayload ? action.payload[0] : false
  if (!information) {
    console.debug('No information found in action', action)
    return ''
  }

  console.debug('getInformationFromPositionHideAction', action)
  return `${action.positionTitle} was hidden: "${information.reason}"`
}

function formatInfo(action) {
  switch (action.typeId) {
    case 'POSITION_HIDE':
    case 'CANDIDATE_POSITION_HIDE':
      return getInformationFromPositionHideAction(action)
    default:
      return ''
  }
}

// eslint-disable-next-line unicorn/prefer-set-has
const positionActionTypes = ['POSITION_HIDE', 'CANDIDATE_POSITION_HIDE']

const generatePositionInformation = (action, positionTitleData) => {
  const titleData = positionTitleData.find(
    data => data.id === action.payload[0].positionId
  )
  const positionTitle =
    titleData && titleData.id && titleData.employer && titleData.title
      ? `${titleData.title} @ ${titleData.employer} (${titleData.id})`
      : ''
  console.debug('addPositionDetails::positionTitle:', positionTitle)
  const withTitle = _.extend(action, {positionTitle})
  return formatInfo(withTitle)
}

const formatLoginHistory = (actions, positionDetails) => {
  console.debug('formatLoginHistory:actions', actions)
  console.debug('formatLoginHistory:positionDetails', positionDetails)

  const extended =
    actions &&
    actions.length > 0 &&
    actions.map(action => {
      return _.extend(action, {
        type: formatType(action.typeId),
      })
    })

  if (!positionDetails) {
    return extended
  }

  if (positionDetails && positionDetails.length > 0) {
    const positionTitleData = positionDetails.map(position => ({
      id: position.id,
      employer: position.employer.name,
      title: position.title,
    }))
    console.debug('formatLoginHistory: title data', positionTitleData)

    const withInfo =
      extended &&
      extended.length > 0 &&
      extended.map(action => {
        if (!positionActionTypes.includes(action.typeId)) {
          return _.extend(action, {info: formatInfo(action)})
        }

        console.warn('withInfo: processing position action', action)

        return _.extend(action, {
          info: generatePositionInformation(action, positionTitleData),
        })
      })

    return withInfo
  }

  return actions
}

const getPositionDetails = async (actions, api) => {
  if (!actions) {
    return actions
  }

  const relevant = actions.filter(action =>
    positionActionTypes.includes(action.typeId)
  )
  const positionIds =
    relevant && relevant.map(action => action.payload[0].positionId)
  if (!positionIds) {
    return []
  }

  if (positionIds && positionIds.length > 0) {
    const asQueryParameters = positionIds.map(id => `ids=${id}`).join(`&`)
    const response = await api.get(`positions?${asQueryParameters}`)
    console.log(`getPositionDetails response:`, response)
    return response && response.data
  }
}

const LoginHistoryController = ($scope, CandidateProfileApi, api) => {
  $scope.paginationOptions = {
    limitOptions: [10, 20, 50],
    selectedLimit: 50,
  }

  $scope.pagination = {
    currentPage: 1,
    totalItems: 0,
  }

  $scope.pageChange = () => {
    const start =
      $scope.paginationOptions.selectedLimit *
      ($scope.pagination.currentPage - 1)
    const end = start + $scope.paginationOptions.selectedLimit
    $scope.history = $scope.allHistory.slice(start, end)
    $scope.$apply()
  }

  $scope.initializeHistory = async () =>
    wrap(async () => {
      const {data: actions} = await CandidateProfileApi.getLoginHistory(
        $scope.candidate.id
      )
      const positionDetails = await getPositionDetails(actions, api)
      const formatted = formatLoginHistory(actions, positionDetails)
      $scope.allHistory = formatted
      $scope.pagination.totalItems = $scope.allHistory.length
      $scope.pageChange()
    })

  $scope.initializeHistory()
}

export {LoginHistoryController}



// WEBPACK FOOTER //
// ./scripts/candidate-profile/login-history/login-history.ctrl.js